import { M3PDinamByActividad } from "./m3-pdinam-by-actividad";


export class M3RegistroTrx {

    public Actividad:string;
    public ID:number;
    public M3PDinamByActividad = new Array<M3PDinamByActividad>();

    //Atributos unico del Front
    public Actual:string = undefined
}